import {HttpClient} from '@web-libs/core/http';
import {CmsRepository} from '@web-libs/features/cms/domain/cms.repository';
import {CmsPage, CmsPageType} from '@web-libs/features/cms/domain/cms.types';
import {getCmsPageTagForInstitution} from '@web-libs/features/cms/api/cms.tags';

export const createCmsRepository = (httpClient: HttpClient): CmsRepository => {
    return {
        getCmsPageForInstitutionByType: async (institutionId: string,
                                               type: CmsPageType) => {
            return httpClient.get<CmsPage>(`public/institutions/${institutionId}/cms/pages/byType`,
                                           {
                                               queryParams: {
                                                   cmsPageType: type
                                               },
                                               tags: [getCmsPageTagForInstitution(institutionId,
                                                                                  type)]
                                           });
        }
    };
};
